import { v4 as uuidv4 } from 'uuid';

export const fixDuplicatedProjectKeys = (json) => {
    Object.keys(json).map((moduleKey) => {
        json[moduleKey].data = fixDuplicatedModuleKeys(json[moduleKey].data);
    });


    return json;
}

export const fixDuplicatedModuleKeys = (json) => {
    let map = {};

    let nodeKeys = Object.keys(json.nodes);
    nodeKeys.forEach((nodeKey) => {
        let newId = uuidv4();
        map[nodeKey] = newId;
    });

    nodeKeys.forEach((nodeKey) => {
        json.nodes[nodeKey].id = map[json.nodes[nodeKey].id];


        let outputKeys = Object.keys(json.nodes[nodeKey].outputs);
        outputKeys.forEach((outKey) => {
            json.nodes[nodeKey].outputs[outKey].connections.forEach((con, i) => {
                json.nodes[nodeKey].outputs[outKey].connections[i].node = map[json.nodes[nodeKey].outputs[outKey].connections[i].node];
            });
        });

        let inputKeys = Object.keys(json.nodes[nodeKey].inputs);
        inputKeys.forEach((outKey) => {
            json.nodes[nodeKey].inputs[outKey].connections.forEach((con, i) => {
                json.nodes[nodeKey].inputs[outKey].connections[i].node = map[json.nodes[nodeKey].inputs[outKey].connections[i].node];
            });
        });
    });

    Object.keys(map).forEach((oldId) => {
        json.nodes[map[oldId]] = JSON.parse(JSON.stringify(json.nodes[oldId]));
        delete json.nodes[oldId];
    });

    // correct also comment links
    for (let i = 0; i < json.comments.length; i++) {
        for (let j = 0; j < json.comments[i].links.length; j++) {
            json.comments[i].links[j] = map[json.comments[i].links[j]];
        }
    }


    return json
}